<template>
    <div class="agreeAudit">
        <el-dialog title="提示" @close="close" :visible.sync="dialogVisible" width="600px">
            <p class="agree">同意该用户成为{{grade}}？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="affirm" :disabled="agree">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {auditPassRejectReturn} from '@/api/extensionAgent'
export default {
    name: 'agreeAudit',
    data() {
        return {
            dialogVisible: false,
            innerid: '',
            grade: '',
            agree: false
        }
    },
    methods: {
        agreeAudit(row) {
            this.innerid = row.innerid
            this.dialogVisible = true
            this.grade = row.leveltypetext
        },
        affirm() {
            if (this.agree) {
                return
            }
            this.agree = true
            this.setLoading(true)
            auditPassRejectReturn({
                data: {innerid: this.innerid, status: '10'},
                success: data => {
                    this.setLoading(false)
                    this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message: '通过成功！'
                    })
                    this.$emit('getList', true)
                    this.$emit('agree', true)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        close() {
            this.agree = false
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .agreeAudit{
        .agree{
            color: #303133;
            text-align: center;
        }
    }
</style>